module.exports = "<p>\r\n  failed-page works!\r\n</p>\r\n"